import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import NoResultsMessage from 'FormsUI/components/common/NoResultsMessage';
import AppLink from 'FormsUI/components/common/AppLink';
import { getUserPreferencesProfileRoute } from 'FormsUI/lib/RouteGenerators';
import { jsx as _jsx } from "react/jsx-runtime";
const SettingsLink = () => /*#__PURE__*/_jsx(AppLink, {
  external: true,
  href: getUserPreferencesProfileRoute(),
  "data-action": "notification-settings",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'editor.form.properties.search.emptySearchSettings'
  })
});
const NoResults = () => /*#__PURE__*/_jsx(TFlex, {
  justify: "center",
  marginBlockStart: "700",
  children: /*#__PURE__*/_jsx(NoResultsMessage, {
    width: "150px",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'editor.form.properties.search.emptySearch',
      options: {
        settings: /*#__PURE__*/_jsx(SettingsLink, {})
      }
    })
  })
});
export default NoResults;